import { LoadingButton } from "@mui/lab";
import {
  Button,
  Checkbox,
  Chip,
  Container,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Paper,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useActividadesEconomicasContext } from "../actividades-economicas-context";
import {
  ActividadEconomicaProvider,
  useActividadEconomicaContext,
} from "./actividad-economica-context";
import { MdArrowBack } from "react-icons/md";
import { ActividadEconomicaAutocomplete } from "app/components";

export function ActividadEconomicaForm() {
  return (
    <ActividadEconomicaProvider>
      <Form />
    </ActividadEconomicaProvider>
  );
}

function Form() {
  const params = useParams();
  const navigate = useNavigate();

  const {
    addActividadEconomica,
    isAdding,
    updateActividadEconomica,
    isUpdating,
    cancel,
  } = useActividadesEconomicasContext();

  const { actividadEconomica, setActividadEconomica, isEditing } =
    useActividadEconomicaContext();

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!!isEditing) {
        return await updateActividadEconomica({
          actividadId: params.actividad_id,
          actividadEconomica,
        });
      } else {
        return await addActividadEconomica({ actividadEconomica });
      }
    } catch (error) {
      console.log(error.message);
    }
  }

  return (
    <Container maxWidth="sm" className="animate__animated animate__fadeIn">
      <Paper
        component="form"
        onSubmit={handleSubmit}
        onReset={cancel}
        sx={{ padding: 2 }}
        variant="outlined"
      >
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <Tooltip title="Atrás">
                  <IconButton
                    onClick={() => navigate("../..", { replace: true })}
                  >
                    <MdArrowBack />
                  </IconButton>
                </Tooltip>

                <Typography variant="h6">
                  {`${!!isEditing ? "Editar" : "Agregar"} actividad económica`}
                </Typography>
              </Stack>

              {!!isEditing && (
                <Chip
                  label={
                    !!actividadEconomica.actividad_economica_verificada
                      ? "Verificado"
                      : "Pendiente"
                  }
                  color={
                    !!actividadEconomica.actividad_economica_verificada
                      ? "success"
                      : "warning"
                  }
                  size="small"
                  variant="outlined"
                />
              )}
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <ActividadEconomicaAutocomplete
              value={actividadEconomica.actividad_economica_id}
              onChange={(value) =>
                setActividadEconomica((state) => ({
                  ...state,
                  actividad_economica_id: value,
                }))
              }
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              type="text"
              label="Detalles"
              value={actividadEconomica.actividad_economica_detalles}
              onChange={(e) =>
                setActividadEconomica((actividad) => ({
                  ...actividad,
                  actividad_economica_detalles: e.target.value,
                }))
              }
              size="small"
              fullWidth
              multiline
              rows={3}
              required
              disabled={!!actividadEconomica.actividad_economica_verificada}
            />
          </Grid>

          <Grid item xs={12}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={actividadEconomica.actividad_economica_principal}
                    onChange={(e) =>
                      setActividadEconomica((actividad) => ({
                        ...actividad,
                        actividad_economica_principal: e.target.checked,
                      }))
                    }
                  />
                }
                label="¿Es un actividad económica principal?"
                disabled={!!actividadEconomica.actividad_economica_verificada}
              />
            </FormGroup>
          </Grid>

          {!actividadEconomica.actividad_economica_verificada && (
            <Grid item xs={12}>
              <Stack direction="row" justifyContent="end" spacing={1}>
                <LoadingButton
                  type="submit"
                  variant="contained"
                  size="small"
                  color={!!isEditing ? "warning" : "success"}
                  loading={!!isUpdating || !!isAdding}
                >
                  {!!isEditing ? "Actualizar" : "Agregar"}
                </LoadingButton>

                <Button
                  type="reset"
                  variant="outlined"
                  size="small"
                  color="inherit"
                  disabled={!!isUpdating || !!isAdding}
                >
                  Cancelar
                </Button>
              </Stack>
            </Grid>
          )}
        </Grid>
      </Paper>
    </Container>
  );
}
